import type { PinnedMessageListItem } from "../lib/authApi";
import { AppIcon } from "./AppIcon";

type PinnedMessagesPanelProps = {
  pins: PinnedMessageListItem[];
  onSelectMessageId: (messageId: string) => void;
  onClose: () => void;
};

function formatPinnedTime(ts: number): string {
  return new Date(ts).toLocaleString("ru-RU", {
    day: "2-digit",
    month: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function PinnedMessagesPanel({ pins, onSelectMessageId, onClose }: PinnedMessagesPanelProps) {
  return (
    <div className="pinned-messages-panel" role="region" aria-label="Закреплённые сообщения">
      <div className="pinned-messages-panel__bar">
        <span className="pinned-messages-panel__icon" aria-hidden="true">
          <AppIcon name="pin" className="pinned-messages-panel__icon-svg" size={16} />
        </span>
        <span className="pinned-messages-panel__title">Закреплённые</span>
        <button type="button" className="pinned-messages-panel__close" onClick={onClose} aria-label="Закрыть список">
          <AppIcon name="x" size={16} />
        </button>
      </div>
      <div className="pinned-messages-panel__results">
        {pins.length === 0 ? (
          <div className="pinned-messages-panel__state">Нет закреплённых сообщений</div>
        ) : (
          <ul className="pinned-messages-panel__list">
            {pins.map((row) => (
              <li key={row.message_id}>
                <button
                  type="button"
                  className="pinned-messages-panel__item"
                  onClick={() => onSelectMessageId(row.message_id)}
                >
                  <span className="pinned-messages-panel__item-top">
                    <span className="pinned-messages-panel__author">
                      {row.author_username ?? row.from_id?.slice(0, 8) ?? "—"}
                    </span>
                    <span className="pinned-messages-panel__time">
                      {row.created_at != null ? formatPinnedTime(row.created_at) : formatPinnedTime(row.pinned_at)}
                    </span>
                  </span>
                  <span className="pinned-messages-panel__preview">
                    {(row.body_preview ?? "").trim() || "Сообщение"}
                  </span>
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
